/**
 * Geschenk ab Bestellwert — führt nur zwei Aktionen aus.
 * Die gesamte Anzeige entsteht serverseitig in snippets/hdd-cart-gift.liquid; beide
 * Warenkorb-Ansichten werden von cart-ajax.js bei jeder Änderung neu geladen.
 *
 * 1. Klick auf „Geschenk sichern" legt das Produkt mit der Eigenschaft _hdd_gift ein.
 * 2. Wächter: Rutscht der Korb unter die Schwelle, nimmt er genau diese Zeile zurück —
 *    sonst zahlt der Kunde für etwas, das als Geschenk angekündigt war. Zeilen OHNE
 *    _hdd_gift (bewusster Kauf des Öffners) bleiben unangetastet.
 *
 * Der Wächter rechnet bewusst mit /cart.js statt mit dem gerenderten Markup: auf normalen
 * Seiten ist die Warenkorb-Schublade leer, bis man sie öffnet — ein Marker im DOM wäre dort
 * nie vorhanden und der Wächter würde genau dann schweigen, wenn er gebraucht wird.
 *
 * Nutzt die Theme-Globalen cartUrl / cartAddUrl / cartChangeUrl / buildCart / cartPageUpdate
 * aus theme-scripts.liquid + cart-ajax.js. Lädt per defer NACH cart-ajax.js.
 */
(function () {
  "use strict";

  if (typeof jQuery === "undefined") return;

  var tag = document.querySelector("script[data-hdd-gift-threshold]");
  var THRESHOLD = tag ? parseInt(tag.getAttribute("data-hdd-gift-threshold"), 10) : 0;
  if (!THRESHOLD || THRESHOLD <= 0) return;

  var busy = false;
  var attempts = 0;
  var MAX_ATTEMPTS = 3;
  var timer = null;

  function onCartPage() {
    return window.location.pathname.indexOf("/cart") > -1;
  }

  // Eigene Anfragen tragen hddInternal und lösen den Wächter NICHT erneut aus —
  // sonst triggert seine eigene /cart.js-Abfrage ihn endlos neu.
  function readCart(done) {
    jQuery.ajax({
      url: cartUrl,
      dataType: "json",
      hddInternal: true,
      success: done,
    });
  }

  function rerender() {
    readCart(function (cart) {
      if (onCartPage()) {
        cartPageUpdate(cart);
      } else {
        // false: die Schublade nicht von selbst aufreissen
        buildCart(cart, false);
      }
    });
  }

  jQuery("body").on("click", "[data-hdd-gift-add]", function () {
    if (busy) return;
    var btn = jQuery(this);
    var variantId = parseInt(btn.attr("data-hdd-gift-add"), 10);
    if (!variantId) return;

    busy = true;
    attempts = 0;
    btn.prop("disabled", true).addClass("is-loading");

    jQuery.ajax({
      type: "POST",
      url: cartAddUrl,
      data: { id: variantId, quantity: 1, properties: { _hdd_gift: "1" } },
      dataType: "json",
      hddInternal: true,
      complete: function () {
        busy = false;
        rerender();
      },
    });
  });

  function guard() {
    if (busy || attempts >= MAX_ATTEMPTS) return;

    readCart(function (cart) {
      if (!cart || !cart.items || !cart.items.length) {
        attempts = 0;
        return;
      }

      var giftKey = null;
      var qualifying = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.properties && item.properties._hdd_gift === "1") {
          giftKey = item.key;
        } else {
          qualifying += item.original_line_price;
        }
      }

      if (!giftKey || qualifying >= THRESHOLD) {
        attempts = 0;
        return;
      }

      attempts++;
      busy = true;
      jQuery.ajax({
        type: "POST",
        url: cartChangeUrl,
        data: { id: giftKey, quantity: 0 },
        dataType: "json",
        hddInternal: true,
        complete: function () {
          busy = false;
          rerender();
        },
      });
    });
  }

  function guardSoon() {
    window.clearTimeout(timer);
    timer = window.setTimeout(guard, 120);
  }

  jQuery(document).on("ajaxComplete", function (event, xhr, settings) {
    if (!settings || settings.hddInternal) return;
    var url = settings.url || "";
    if (url.indexOf("/cart") === -1) return;
    guardSoon();
  });

  jQuery(function () {
    guardSoon();
  });
})();
